<template>
  <div
    class="gerenshiming box"
    :style="
      authType === 'unAuth'
        ? `background-image: url(${bg1});`
        : `background-image: url(${bg2});`
    "
  >
    <div class="left" v-if="authType === 'unAuth'">
      <div class="title">个人实名认证</div>
      <div class="desc">
        应电子签名相关法律要求，请补充个人真实信息以确保签署者的真实身份。
      </div>
      <el-button type="primary" class="button" @click="$router.push({ name: 'UserAuth' })"
        >前往实名</el-button
      >
    </div>
    <div class="left" v-if="authType === 'unCompanyAuth'">
      <div class="title">企业实名认证</div>
      <div class="desc">完成企业认证，开启“中能E签”完整体验之旅</div>
      <el-button type="primary" class="button" @click="toqiye">前往认证</el-button>
    </div>
    <div class="right">
      <img
        src="~@/assets/image/home/gerenshiming/2.png"
        alt=""
        v-if="authType === 'unAuth'"
      />
      <img src="~@/assets/image/home/gerenshiming/3.webp" alt="" v-else />
    </div>
  </div>
</template>

<script>
import userinfo from "@/mixins/userinfo";
import bg1 from "@/assets/image/home/gerenshiming/1.webp";
import bg2 from "@/assets/image/home/gerenshiming/4.webp";
export default {
  mixins: [userinfo],
  components: {},
  data() {
    return {bg1,bg2};
  },
  created() {},
  computed: {},
  methods: {
    toqiye() {
      this.showMode1();
    },
  },
};
</script>

<style scoped lang="scss">
@use '../homeStyle.scss' as *;
.gerenshiming {
  width: 100%;
  height: 160px;
  display: flex;
  padding: 0 30px;
  align-items: center;
  justify-content: space-between;
  background-size: 100% 100%;
  border-radius: 4px;
  .left {
    .title {
      font-family: "Noto Sans SC";
      font-size: 20px;
      font-weight: 500;
      font-variation-settings: "opsz" auto;
      font-feature-settings: "kern" on;
      color: #262626;
    }
    .desc {
      font-family: "Noto Sans SC";
      font-size: 12px;
      font-weight: 350;
      line-height: 24px;
      text-align: center;
      color: #666666;
      margin: 10px 0;
      z-index: 1;
    }
    .button {
      width: 120px;
      height: 34px;
    }
  }
  .right {
    img {
      width: 128px;
      height: auto;
    }
  }
}
</style>
